export enum EMakeAChoice {
  Text = "Enum.Make_A_Choice",
  Value = -1,
}